import Vue from 'vue'
import Vuex from 'vuex'

import preRepairOrder from '@/views/preRepairOrder/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // keep-alive 缓存的路由name 必须与组件的name一致
    keepInclude: []
  },
  mutations: {
    SET_KEEP_INCLUDES: (state, data) => {
      state.keepInclude = data;
    },
    ADD_KEEP_INCLUDES: (state, data) => {
      state.keepInclude = [...state.keepInclude, data];
    }
  },
  actions: {
    addKeepIncludes: ({ state, commit }, value) => {
      // 如果不在缓存里面 才追加进去
      if (!state.keepInclude.includes(value)) {
        commit('ADD_KEEP_INCLUDES', value)
      }
    },
    removeKeepIncludes: ({ state, commit }, value) => {
      // 去掉keep缓存
      const index = state.keepInclude.indexOf(value)
      if (index !== -1) {
        const arr = Object.assign([], state.keepInclude)
        arr.splice(index, 1)
        commit('SET_KEEP_INCLUDES', arr)
      }
    },
  },
  getters: {
    keepInclude: (state) => {
      return state.keepInclude
    }
  },
  modules: {
    preRepairOrder
  }
})
